export default "__VITE_ASSET__xDoiJ163__"